import React from 'react';

import { getApiAxiosInstance } from '../../utils/network';

import styles from './notifications.scss';

const Notifications = (props) => {
    const { user } = props;

    const axiosInstance = getApiAxiosInstance();
    const stopImpersonating = async () => {
        await axiosInstance.post(`/v1/auth/impersonate/stop`);

        // eslint-disable-next-line no-restricted-globals
        location.href = `/home`;
    };

    return (
        <div className={`${styles.notifications}`}>
            <div className={`${styles.notification} sub-header`}>
                <div className={`d-flex align-items-center justify-content-center`}>
                    <span>Impersonating {user.email}, Use Caution.</span>
                    <span className="pl36 stop-impersonating" onClick={stopImpersonating}>STOP IMPERSONATING</span>
                </div>
            </div>
        </div>
    );
};

export default Notifications;
